<template>
  <v-card-title
    class="subtitle-1 font-weight-bold d-flex align-center pt-0 pl-2"
  >
    <v-avatar
      color="primary"
      size="24"
      class="mr-3 white--text text-caption font-weight-bold"
    >
      {{ step }}
    </v-avatar>
    {{ title }}
  </v-card-title>
</template>

<script>
export default {
  name: 'TarjetaTituloPaso',
  props: {
    step: { type: [String, Number], required: true },
    title: { type: String, required: true },
  },
};
</script>
